import React, { useState, useEffect } from 'react';
import { ShieldCheck, ServerCrash, Loader2 } from 'lucide-react';

const SharedSSHUnlock = ({ tenant, status, errorMessage, onConnect, title = "Secure Access", description = "Unlock this instance to access real-time logs, database, and files." }) => {
  const defaultIp = tenant?.vpsId || tenant?.ip || '';

  const [ip, setIp] = useState(defaultIp);
  const [username, setUsername] = useState('ubuntu');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (defaultIp && !ip) setIp(defaultIp);
  }, [defaultIp, ip]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onConnect) {
      onConnect(ip, username, password);
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6 bg-slate-50 overflow-hidden w-full h-full relative z-10">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-indigo-50 text-indigo-600 mb-4 ring-8 ring-indigo-50/50">
            <ShieldCheck size={32} />
          </div>
          <h2 className="text-xl font-bold text-slate-800">{title}</h2>
          <p className="text-slate-500 text-sm mt-2">{description}</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          {errorMessage && status === 'error' && (
            <div className="p-4 bg-red-50 border border-red-100 text-red-700 text-sm rounded-xl flex items-start gap-3">
              <ServerCrash size={20} className="mt-0.5 shrink-0 text-red-500" />
              <span className="font-medium">{errorMessage}</span>
            </div>
          )}

          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">VPS IP Address</label>
            <input 
              type="text" 
              required 
              value={ip} 
              disabled 
              className="w-full px-4 py-2.5 border border-slate-200 bg-slate-50 text-slate-500 cursor-not-allowed rounded-xl text-sm font-mono" 
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Username</label>
            <input 
              type="text" 
              required 
              value={username} 
              disabled 
              className="w-full px-4 py-2.5 border border-slate-200 bg-slate-50 text-slate-500 cursor-not-allowed rounded-xl text-sm font-mono" 
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-1.5">Password</label>
            <input 
              type="password" 
              required 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              className="w-full px-4 py-2.5 border border-slate-300 rounded-xl focus:ring-4 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm" 
              placeholder="Enter SSH Password" 
              disabled={status === 'connecting'} 
              autoFocus 
            />
          </div>
          <div className="pt-4">
            <button 
              type="submit" 
              disabled={status === 'connecting' || !password} 
              className="w-full flex justify-center items-center gap-2 px-4 py-3 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 focus:ring-4 focus:ring-indigo-500/30 font-semibold transition-all disabled:opacity-70 disabled:cursor-not-allowed shadow-sm"
            >
              {status === 'connecting' ? <><Loader2 size={20} className="animate-spin" /> Authenticating...</> : 'Unlock Secure Access'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SharedSSHUnlock;
